module.exports = __webpack_public_path__ + "static/scale-model-of-mill-city-museum-in-minneapolis-minnesota-0a4236cb64d627b94dcbc8b604e66cf2.png";